module.exports = __webpack_public_path__ + "img/logo-app-store.b51208b2.png";